import { BookingPaidCalendarInterface } from 'common/types/entities/booking-paid-calendar-interface'
import { buyMainOffer } from 'publisher/api/paypalRestApi'
import { pageSelectors } from 'publisher/store'
import { PaymentButtonEntityInterface } from 'src/shared/entities/payment-button/payment-button.schema'
import { OldEntityInterface } from '../../../common/types/entities/OldEntityInterface'
import usePage from '../usePage'
import usePaymentSubmit from './usePaymentSubmit'

const usePaypalRestPaymentHandler = (
  entity:
    | OldEntityInterface
    | PaymentButtonEntityInterface
    | BookingPaidCalendarInterface,
) => {
  const { errors, isLoading, submit } = usePaymentSubmit(entity)
  const pageId = usePage(pageSelectors.getPageId)

  const handleSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault()
    submit(async body => {
      const { data } = await buyMainOffer(pageId, {
        payment_form: body,
      })

      if (data.redirect) {
        window.location.assign(data.redirect)
        return
      }
    })
  }

  return { errors, isLoading, handleSubmit }
}

export default usePaypalRestPaymentHandler
